import {AdminModule} from './admin/admin.module';
import {AgentModule} from './agent/agent.module';
import {BrowserModule} from '@angular/platform-browser';
import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule, Http, BrowserXhr} from '@angular/http';

import {AppComponent} from './app.component';
import {LoginComponent} from './agent/login/login.component';
import {AppRoutingModule} from './app.routing';
import {CredentialXhrService} from './shared/etc/credentialxhr.service';
import {HttpLoaderFactory} from './shared/factory/translatehttploaderfactory';
import {CountryModule} from './shared/module/country.module';
import {CountryPipe} from './shared/pipe/country.pipe';
import {ErrorhandlerProvider} from './shared/provider/errorhandlerprovider';
import {CryptoService} from './shared/service/crypto.service';
import {RequestService} from './shared/service/request.service';
import {SessionService} from './shared/service/session.service';
import {UserService} from './shared/service/user.service';
import {LocationStrategy, HashLocationStrategy, PathLocationStrategy} from '@angular/common';
import {TranslateModule, TranslateLoader, TranslatePipe} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

import {MobilecompanyPipe} from './shared/pipe/mobilecompany.pipe';
import {CurrencyPipe} from './shared/pipe/currency.pipe';
import {DatexPipe} from './shared/pipe/datex.pipe';
import {PageNotFoundComponent} from './pagenotfound/pagenotfound.component';
import {AdminGuard} from './shared/authguard/adminguard.service';
import {DynamicTabsDirective} from './shared/directive/dynamic-tabs/dynamictab.component';
import {SharedModule} from './shared/module/shared/shared.module';
import {MonthPipe} from './shared/pipe/month.pipe';
import {GenderPipe} from './shared/pipe/gender.pipe';
import {AgentServiceProvider} from './shared/provider/agentservice.provider';
import {Base64Service} from './shared/service/base64.service';
import {LicenseBlurService} from './shared/service/licenseblur.service';
import {RandomStringService} from './shared/service/randomstring.service';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import { KeycodeService } from './shared/service/keycode.service';
import { AdminService } from './shared/service/admin/admin.service';
import { AgentService } from './shared/service/agent.service';
import { FileLoader } from './shared/component/fileloader/fileloader';
import { ImageProcessor } from './shared/component/imageprocessor/imageprocessor';
import { BrowserService } from './shared/service/browser.service';
import { AdminComponent } from './admin/admin.component';
import { AgentComponent } from './agent/agent.component';
import { DocumentQueryService } from './shared/service/documentquery.service';
import { CacheService } from './shared/service/cache.service';

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    AdminComponent, AgentComponent,
    KeycodeService,
    LicenseBlurService,
    RandomStringService,
    AdminGuard,
    AdminService,
    AgentServiceProvider,
    RequestService, UserService, TranslatePipe, ErrorhandlerProvider, CryptoService, Base64Service,
    SessionService,
    {provide: BrowserXhr, useClass: CredentialXhrService},
    {provide: LocationStrategy, useClass: PathLocationStrategy},
    FileLoader,
    ImageProcessor,
    BrowserService,
    DocumentQueryService,
    CacheService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts